import { useMemo, useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { Redirect } from '@shopify/app-bridge/actions';
import { useUserDataStore } from '@/stores/userDataStore';
import { useShallow } from 'zustand/react/shallow';

const useRedirect = () => {
  const router = useRouter();
  const { shopifyApp } = useUserDataStore(useShallow((state) => ({ shopifyApp: state.shopifyApp })));

  const redirect = useMemo(() => (shopifyApp ? Redirect.create(shopifyApp) : null), [shopifyApp]);

  const dispatchRedirect = useCallback(
    (path: string) => {
      if (!shopifyApp || !redirect) {
        router.push(path);
        return;
      }

      try {
        redirect.dispatch(Redirect.Action.APP, path);
      } catch (error) {
        router.push(path);
      }
    },
    [redirect]
  );

  return { dispatchRedirect };
};

export default useRedirect;
